import './PageCard.scss';

export default function PageCard({ children, className = '' }) {
    return <div className={`ui-page-card ${className}`.trim()}>{children}</div>;
}
